// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

p,
a,
button,
h1,
h2,
h3,
h4,
h5 {
  font-family: "Open Sans", sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.arjun {
  position: fixed;
  z-index: 99999;
  right: 0px;
  top: 0px;
  min-height: 100vh;
  width: 350px;
  background: #fff;
}

.activitie {
  position: fixed;
  z-index: 11;
  top: 0;
  right: 410px;
  background: #fff;
  width: 700px;
  box-shadow: 0px 0px 10px 0px #00000040;
  height: 100%;
  overflow: auto;
}

.addNotes.active .cstAccordion {
  overflow: auto;
  height: calc(100vh - 355px);
  padding-right: 10px;
}

.addNotes .notesForm {
  display: none;
}
.addNotes.active .notesForm {
  display: block;
}
.submitBtn {
  background: #5544dc;
  color: #fff;
  border: 0px;
  min-width: 100px;
  padding: 5px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 30px;
}

.overFlowPoup {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  /* background: #000; */
  z-index: 10;
  /* opacity: 0.5; */
}

.dialBox .activitieScree {
  position: relative;
  width: 700px;
  height: 100%;
  right: 100%;
  margin-right: 20px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px #00000040;
  transition: all, 0.5s;
}

.dialBox .activitieScree.active {
  opacity: 1;
  width: 700px;
}

.activitieScree .closeTitle {
  background: #000;
  color: #fff;
  padding: 10px 10px 6px;
  font-size: 18px;
}
.activitieScree .closeTitle .close {
  background: none;
  color: #fff;
  border: 0;
  font-size: 24px;
  padding: 0;
  margin: 0;
  line-height: 18px;
}

.cstAccordion .accordion-button:not(.collapsed) {
  background: none;
  color: #000;
  padding: 15px 0;
  border-bottom: 1px solid #dee2e6;
}
.cstAccordion .accordion-button:focus {
  box-shadow: none;
}
.cstAccordion .accordion-button {
  background: none;
  color: #000;
  padding: 15px 0;
}
.cstAccordion .accordion-body {
  padding: 15px 0;
}
.cstAccordion .accordion-button .callIcon {
  font-size: 20px;
  margin-right: 10px;
}

.cstAccordion .addNote {
  border: 1px solid #949494;
  padding: 15px 15px 5px;
  font-size: 15px;
  border-radius: 10px;
  position: relative;
  margin: 30px 0 20px;
}
.cstAccordion .addNote .yourNote {
  position: absolute;
  top: -20px;
  background: #fff;
  padding: 2px 4px;
  font-size: 15px;
  color: #4f3edb;
  font-weight: 600;
}
.cstAccordion .addNote .yourNote span {
  font-size: 20px;
}

.dialBox {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  min-height: 84vh;
  position: relative;
}
.dialBox .activitieBtn {
  background: #fff;
  border: 1px solid #000;
  border-radius: 30px;
  padding: 5px;
  font-size: 15px;
  width: 130px;
}
.dialBox .activitieBtn span {
  font-size: 22px;
  line-height: 22px;
}
.dialBox .activitieBtn:hover,
.dialBox .activeActivity {
  background: #5544dc;
  color: #fff;
  border-color: #5544dc;
}

.dialBox .callTransfer {
  display: inline-block;
  width: 200px;
  background: #fff;
  border: 1px solid #000;
  border-radius: 30px;
  padding: 8px;
  font-size: 16px;
}

.callBox {
  text-align: center;
}

.callBox .icon {
  background: #15b76c;
  height: 60px;
  width: 60px;
  display: inline-flex;
  text-align: center;
  color: #fff;
  font-size: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}
.callBox .number {
  font-size: 30px;
  font-weight: 500;
}

.callRunSec {
  background: #ebebeb;
  padding: 20px;
  border-radius: 15px;
  text-align: center;
}
.callRunSec .iconOpt {
  display: flex;
  justify-content: space-around;
}
.callRunSec .iconOpt .icon {
  font-size: 38px;
  border: 0px;
  background: none;
}
.callRunSec .iconOpt .icon > p {
  font-size: 12px;
}

.callRunSec .iconOpt {
  display: flex;
}

.callRunSec .callEndIcon {
  background: #db332a;
  height: 70px;
  width: 70px;
  display: inline-flex;
  text-align: center;
  color: #fff;
  font-size: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}

.callRunSec .callEndIcon:hover {
  background-color: #a1312b;
  color: white;
}

.callRunSec .callpick:hover {
  background-color: #139055;
  color: white;
}

.callRunSec .callpick {
  background: #15b76c;
  height: 70px;
  width: 70px;
  display: inline-flex;
  text-align: center;
  color: #fff;
  font-size: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}

.loginForm .title {
  color: #3c4248;
  font-size: 30px;
}
.loginForm .subTitle {
  color: #3c4248;
  font-size: 16px;
}
.loginForm .otpBoxes div {
  gap: 15px;
}
.loginForm .otpBoxes div {
  gap: 15px;
  justify-content: space-between;
}
.loginForm .otpBoxes input {
  border: 1px solid #c7c6c6;
  border-radius: 6px;
  background: #fff;
  height: 50px;
  width: 50px !important;
}
.loginForm .resend {
  color: #3c4248;
}

.loginForm .footerAuth {
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: 0.2rem 0rem;
}
.loginForm .resend button {
  color: #5544dc;
  text-decoration: underline;
  font-weight: 700;
  border: 0;
  padding: 0;
  background-color: transparent;
}
.loginForm .submitBtn {
  background: #5544dc;
  color: #fff;
  border: 0;
  padding: 10px;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 500;
}

.fromImage h3 {
  font-size: 22px;
  color: #3c4248;
  font-weight: 600;
}
.fromImage p {
  color: #63676b;
  font-size: 15px;
  font-weight: 500;
}

.reqConnection h3 {
  font-size: 18px;
  color: #131313;
  font-weight: 600;
}
.reqConnection p {
  color: #464646;
}
.reqConnection .reqBtn {
  background: #5544dc;
  color: #fff;
  min-width: 300px;
  font-size: 17px;
  font-weight: 700;
  border: 0px;
  padding: 8px;
  border-radius: 6px;
}
.reqConnection .p {
  color: #464646;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;;;;EAQE,oCAAoC;AACtC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,eAAe;EACf,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap\");\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: \"Open Sans\", sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\np,\r\na,\r\nbutton,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n  font-family: \"Open Sans\", sans-serif;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\r\n}\r\n\r\n.arjun {\r\n  position: fixed;\r\n  z-index: 99999;\r\n  right: 0px;\r\n  top: 0px;\r\n  min-height: 100vh;\r\n  width: 350px;\r\n  background: #fff;\r\n}\r\n\r\n.activitie {\r\n  position: fixed;\r\n  z-index: 11;\r\n  top: 0;\r\n  right: 410px;\r\n  background: #fff;\r\n  width: 700px;\r\n  box-shadow: 0px 0px 10px 0px #00000040;\r\n  height: 100%;\r\n  overflow: auto;\r\n}\r\n\r\n.addNotes.active .cstAccordion {\r\n  overflow: auto;\r\n  height: calc(100vh - 355px);\r\n  padding-right: 10px;\r\n}\r\n\r\n.addNotes .notesForm {\r\n  display: none;\r\n}\r\n.addNotes.active .notesForm {\r\n  display: block;\r\n}\r\n.submitBtn {\r\n  background: #5544dc;\r\n  color: #fff;\r\n  border: 0px;\r\n  min-width: 100px;\r\n  padding: 5px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  border-radius: 30px;\r\n}\r\n\r\n.overFlowPoup {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  /* background: #000; */\r\n  z-index: 10;\r\n  /* opacity: 0.5; */\r\n}\r\n\r\n.dialBox .activitieScree {\r\n  position: relative;\r\n  width: 700px;\r\n  height: 100%;\r\n  right: 100%;\r\n  margin-right: 20px;\r\n  background: #fff;\r\n  box-shadow: 0px 0px 10px 0px #00000040;\r\n  transition: all, 0.5s;\r\n}\r\n\r\n.dialBox .activitieScree.active {\r\n  opacity: 1;\r\n  width: 700px;\r\n}\r\n\r\n.activitieScree .closeTitle {\r\n  background: #000;\r\n  color: #fff;\r\n  padding: 10px 10px 6px;\r\n  font-size: 18px;\r\n}\r\n.activitieScree .closeTitle .close {\r\n  background: none;\r\n  color: #fff;\r\n  border: 0;\r\n  font-size: 24px;\r\n  padding: 0;\r\n  margin: 0;\r\n  line-height: 18px;\r\n}\r\n\r\n.cstAccordion .accordion-button:not(.collapsed) {\r\n  background: none;\r\n  color: #000;\r\n  padding: 15px 0;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n.cstAccordion .accordion-button:focus {\r\n  box-shadow: none;\r\n}\r\n.cstAccordion .accordion-button {\r\n  background: none;\r\n  color: #000;\r\n  padding: 15px 0;\r\n}\r\n.cstAccordion .accordion-body {\r\n  padding: 15px 0;\r\n}\r\n.cstAccordion .accordion-button .callIcon {\r\n  font-size: 20px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.cstAccordion .addNote {\r\n  border: 1px solid #949494;\r\n  padding: 15px 15px 5px;\r\n  font-size: 15px;\r\n  border-radius: 10px;\r\n  position: relative;\r\n  margin: 30px 0 20px;\r\n}\r\n.cstAccordion .addNote .yourNote {\r\n  position: absolute;\r\n  top: -20px;\r\n  background: #fff;\r\n  padding: 2px 4px;\r\n  font-size: 15px;\r\n  color: #4f3edb;\r\n  font-weight: 600;\r\n}\r\n.cstAccordion .addNote .yourNote span {\r\n  font-size: 20px;\r\n}\r\n\r\n.dialBox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-around;\r\n  height: 100%;\r\n  min-height: 84vh;\r\n  position: relative;\r\n}\r\n.dialBox .activitieBtn {\r\n  background: #fff;\r\n  border: 1px solid #000;\r\n  border-radius: 30px;\r\n  padding: 5px;\r\n  font-size: 15px;\r\n  width: 130px;\r\n}\r\n.dialBox .activitieBtn span {\r\n  font-size: 22px;\r\n  line-height: 22px;\r\n}\r\n.dialBox .activitieBtn:hover,\r\n.dialBox .activeActivity {\r\n  background: #5544dc;\r\n  color: #fff;\r\n  border-color: #5544dc;\r\n}\r\n\r\n.dialBox .callTransfer {\r\n  display: inline-block;\r\n  width: 200px;\r\n  background: #fff;\r\n  border: 1px solid #000;\r\n  border-radius: 30px;\r\n  padding: 8px;\r\n  font-size: 16px;\r\n}\r\n\r\n.callBox {\r\n  text-align: center;\r\n}\r\n\r\n.callBox .icon {\r\n  background: #15b76c;\r\n  height: 60px;\r\n  width: 60px;\r\n  display: inline-flex;\r\n  text-align: center;\r\n  color: #fff;\r\n  font-size: 40px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 100%;\r\n}\r\n.callBox .number {\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n}\r\n\r\n.callRunSec {\r\n  background: #ebebeb;\r\n  padding: 20px;\r\n  border-radius: 15px;\r\n  text-align: center;\r\n}\r\n.callRunSec .iconOpt {\r\n  display: flex;\r\n  justify-content: space-around;\r\n}\r\n.callRunSec .iconOpt .icon {\r\n  font-size: 38px;\r\n  border: 0px;\r\n  background: none;\r\n}\r\n.callRunSec .iconOpt .icon > p {\r\n  font-size: 12px;\r\n}\r\n\r\n.callRunSec .iconOpt {\r\n  display: flex;\r\n}\r\n\r\n.callRunSec .callEndIcon {\r\n  background: #db332a;\r\n  height: 70px;\r\n  width: 70px;\r\n  display: inline-flex;\r\n  text-align: center;\r\n  color: #fff;\r\n  font-size: 40px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 100%;\r\n}\r\n\r\n.callRunSec .callEndIcon:hover {\r\n  background-color: #a1312b;\r\n  color: white;\r\n}\r\n\r\n.callRunSec .callpick:hover {\r\n  background-color: #139055;\r\n  color: white;\r\n}\r\n\r\n.callRunSec .callpick {\r\n  background: #15b76c;\r\n  height: 70px;\r\n  width: 70px;\r\n  display: inline-flex;\r\n  text-align: center;\r\n  color: #fff;\r\n  font-size: 40px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 100%;\r\n}\r\n\r\n.loginForm .title {\r\n  color: #3c4248;\r\n  font-size: 30px;\r\n}\r\n.loginForm .subTitle {\r\n  color: #3c4248;\r\n  font-size: 16px;\r\n}\r\n.loginForm .otpBoxes div {\r\n  gap: 15px;\r\n}\r\n.loginForm .otpBoxes div {\r\n  gap: 15px;\r\n  justify-content: space-between;\r\n}\r\n.loginForm .otpBoxes input {\r\n  border: 1px solid #c7c6c6;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  height: 50px;\r\n  width: 50px !important;\r\n}\r\n.loginForm .resend {\r\n  color: #3c4248;\r\n}\r\n\r\n.loginForm .footerAuth {\r\n  position: absolute;\r\n  bottom: 0;\r\n  text-align: center;\r\n  padding: 0.2rem 0rem;\r\n}\r\n.loginForm .resend button {\r\n  color: #5544dc;\r\n  text-decoration: underline;\r\n  font-weight: 700;\r\n  border: 0;\r\n  padding: 0;\r\n  background-color: transparent;\r\n}\r\n.loginForm .submitBtn {\r\n  background: #5544dc;\r\n  color: #fff;\r\n  border: 0;\r\n  padding: 10px;\r\n  border-radius: 6px;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n}\r\n\r\n.fromImage h3 {\r\n  font-size: 22px;\r\n  color: #3c4248;\r\n  font-weight: 600;\r\n}\r\n.fromImage p {\r\n  color: #63676b;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n}\r\n\r\n.reqConnection h3 {\r\n  font-size: 18px;\r\n  color: #131313;\r\n  font-weight: 600;\r\n}\r\n.reqConnection p {\r\n  color: #464646;\r\n}\r\n.reqConnection .reqBtn {\r\n  background: #5544dc;\r\n  color: #fff;\r\n  min-width: 300px;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  border: 0px;\r\n  padding: 8px;\r\n  border-radius: 6px;\r\n}\r\n.reqConnection .p {\r\n  color: #464646;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
